import http from "@/axios";
import {CardInfo, CardState, CardType} from './types';
import {ArtifactInfo} from "@/store/artifact/types";
import PlayerStore from "@/store/player";

export default class CardStore {

    public static fetchCardsInfo(): Promise<CardInfo[]> {
        return http.get('/api/card/info')
            .then(r => r.data)
            .then(contentObj => {
                const res: CardInfo[] = [];
                let activeCardType: CardType | null = null;
                for (const obj of contentObj) {
                    let card = Object.assign(new CardInfo(), obj);
                    res.push(card);
                    if (card.active) {
                        activeCardType = card.cardType;
                    }
                }
                PlayerStore.SET_CARD_STATE({ activeCard: activeCardType });
                return res;
            });
    }

    public static useCard(cardType: CardType): Promise<CardState> {
        return http.get('/api/card/use?cardType=' + cardType.toString())
            .then(r => r.data)
            .then(cardState => {
                let cs = Object.assign(new CardState(), cardState);
                PlayerStore.SET_CARD_STATE(cs);
                return cs;
            });
    };

    public static cancelActiveCard(): Promise<void> {
        return http.post("/api/card/cancel")
            .then(() => {
                PlayerStore.SET_CARD_STATE({ activeCard: null });
            });
    }
}
